import $ from 'jquery';
const ObservableMethods = Symbol("ObservableMethods");
const ObservableProperties = Symbol("ObservableProperties");
export function Observable(Base) {
    return class extends Base {
        constructor(...args) {
            super(...args);
            if (!this.changed)
                throw new Error("Cannot mark a class without a changed() method as Observable.");
            const tagged_methods = Base.prototype[ObservableMethods];
            if (tagged_methods) {
                tagged_methods.forEach((descriptor_and_async, method_name) => {
                    const asnc = descriptor_and_async[1];
                    let current = this;
                    let new_desc = undefined;
                    while (!new_desc && current.name !== 'Object') {
                        const names = Object.getOwnPropertyNames(current);
                        if (names.includes(method_name)) {
                            new_desc = Object.getOwnPropertyDescriptor(current, method_name);
                            const orig_fn = new_desc.value;
                            if (asnc)
                                new_desc.value = async (...args) => {
                                    return orig_fn.apply(this, args).then((res) => { this.changed(); return res; });
                                };
                            else
                                new_desc.value = (...args) => {
                                    let res = orig_fn.apply(this, args);
                                    this.changed();
                                    return res;
                                };
                            Object.defineProperty(this, method_name, new_desc);
                        }
                        current = Object.getPrototypeOf(current);
                    }
                });
            }
            const tagged_props = Base.prototype[ObservableProperties];
            if (tagged_props) {
                tagged_props.forEach((descriptor, property_name) => {
                    let current = this;
                    let orig_set = descriptor.set;
                    let new_desc;
                    while (!new_desc && current.name !== 'Object') {
                        const names = Object.getOwnPropertyNames(current);
                        if (names.includes(property_name)) {
                            new_desc = Object.getOwnPropertyDescriptor(current, property_name);
                            new_desc.set = (v) => {
                                orig_set.call(this, v);
                                this.changed();
                            };
                            Object.defineProperty(this, property_name, new_desc);
                        }
                        current = Object.getPrototypeOf(current);
                    }
                });
            }
        }
    };
}
export function Refresh(target, property_key, descriptor) {
    target[ObservableMethods] = target[ObservableMethods] || new Map();
    target[ObservableMethods].set(property_key, [descriptor, false]);
}
export function AsyncRefresh(target, property_key, descriptor) {
    target[ObservableMethods] = target[ObservableMethods] || new Map();
    target[ObservableMethods].set(property_key, [descriptor, true]);
}
export function RefreshProp(target, property_key, descriptor) {
    target[ObservableProperties] = target[ObservableProperties] || new Map();
    target[ObservableProperties].set(property_key, descriptor);
}
export function WaitFor() {
    return (target, propertyKey, descriptor) => {
        const click_interceptor = (e) => { e.stopPropagation(); e.preventDefault(); };
        const originalMethod = descriptor.value;
        descriptor.value = async function (...args) {
            document.addEventListener("click", click_interceptor, true);
            $("#loader").attr("class", "").css("opacity", 1);
            $("body").css("opacity", 0.5);
            const value = await originalMethod.apply(this, args);
            $("body").css("opacity", 1);
            $("#loader").css("opacity", 0).attr("class", "hidden");
            document.removeEventListener("click", click_interceptor, true);
            return value;
        };
    };
}
